import { IconType, SvgIcon } from './SvgIcon';

export const EmptyDotIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 12 12">
    <circle cx="6" cy="6" r="5.5" fill="none" stroke="currentColor" strokeWidth={1} />
  </SvgIcon>
);

EmptyDotIcon.displayName = 'EmptyDotIcon';
